// @ts-nocheck
import { getCookie, setCookie } from "@insite/client-framework/Common/Cookies";
import { HasShellContext, withIsInShell } from "@insite/client-framework/Components/IsInShell";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import loadWarehouses from "@insite/client-framework/Store/Components/FindLocationModal/Handlers/LoadWarehouses";
import changeCustomerContext from "@insite/client-framework/Store/Context/Handlers/ChangeCustomerContext";
import updatePickUpWarehouse from "@insite/client-framework/Store/Context/Handlers/UpdatePickUpWarehouse";
import { getWarehousesDataView } from "@insite/client-framework/Store/Data/Warehouses/WarehousesSelectors";
import { WarehouseModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import constants from "@store/constants";
import setMyWarehouse from "@store/Framework/Store/Store/Data/MyWarehouse/Handlers/SetMyWarehouse";
import React, { FC } from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: ApplicationState) => ({
    pickUpWarehouse: state.context.session.pickUpWarehouse,
    warehousesDataView: getWarehousesDataView(state, state.components.findLocationModal.getWarehousesParameter),
    fulfillmentMethod: state.context.session.fulfillmentMethod,
});

const mapDispatchToProps = {
    loadWarehouses,
    updatePickUpWarehouse,
    changeCustomerContext,
    setMyWarehouse,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasShellContext;

export interface WarehouseGeolocatorStyles {}

export const warehouseGeolocatorStyles: WarehouseGeolocatorStyles = {};

interface OwnProps extends WidgetProps {
    fields: {};
}

const WarehouseGeolocator: FC<Props> = ({
    pickUpWarehouse,
    warehousesDataView,
    loadWarehouses,
    updatePickUpWarehouse,
    setMyWarehouse,
}) => {
    React.useEffect(() => {
        if (!getCookie("storeHasSetClosestWarehouse") && !warehousesDataView.value && !warehousesDataView.isLoading) {
            navigator.geolocation.getCurrentPosition(
                position => {
                    loadWarehouses({
                        search: "",
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude,
                        radius: 0,
                        sort: "Distance",
                    });
                },
                () => {
                    const defaultLat = constants.geolocation.defaultLat;
                    const defaultLong = constants.geolocation.defaultLong;
                    loadWarehouses({
                        search: "",
                        latitude: defaultLat,
                        longitude: defaultLong,
                        radius: 0,
                        sort: "Distance",
                    });
                },
            );
        }
    }, []);
    React.useEffect(() => {
        if (!getCookie("storeHasSetClosestWarehouse") && warehousesDataView.value && !warehousesDataView.isLoading) {
            const closestWarehouse = warehousesDataView.value[0];
            if (!pickUpWarehouse || closestWarehouse.id !== pickUpWarehouse?.id) {
                selectWarehouse(warehousesDataView.value[0]);
            }
        }
    }, [warehousesDataView]);

    const selectWarehouse = async (pickUpWarehouse: WarehouseModel) => {
        if (!getCookie("storeHasSetClosestWarehouse")) {
            await setMyWarehouse({
                name: pickUpWarehouse.name,
                onSuccess: async () => {
                    await selectWarehouseCallback(pickUpWarehouse);
                },
                onError: async () => {
                    await selectWarehouseCallback(pickUpWarehouse);
                },
            });
        }
    };

    const selectWarehouseCallback = async (pickUpWarehouse: WarehouseModel) => {
        await updatePickUpWarehouse({ pickUpWarehouse });
        setCookie("storeHasSetClosestWarehouse", "true");
        window.location.reload();
    };

    return <></>;
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withIsInShell(WarehouseGeolocator)),
    definition: {
        displayName: "Header Geolocator Widget",
        icon: "location-dot",
        group: "Common",
    },
};

export default widgetModule;
